import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function DialogCampanhaOfertaAlternativas({
  PaperComponent,
  open,
  onClose,
  ofertaClienteAlternativasSelecionada,
  alternativasOfertasCliente,
  formOfertaClienteAlternativa,
  setFormOfertaClienteAlternativa,
  alternativaInput,
  setAlternativaInput,
  materiaisCombo,
  carregarMateriaisCombo,
  materialLabel,
  guardarOfertaClienteAlternativa,
  abrirEditarAlternativaOfertaCliente,
  apagarAlternativaOfertaCliente,
}) {
  const alternativas = alternativasOfertasCliente?.[ofertaClienteAlternativasSelecionada?.id] || [];

  const refsBloqueadas = alternativas
    .filter((a) => String(a.id) !== String(formOfertaClienteAlternativa.id || ""))
    .map((a) => String(a.refmaterialalternativo || ""));

  if (ofertaClienteAlternativasSelecionada?.refmaterialoferta) {
    refsBloqueadas.push(String(ofertaClienteAlternativasSelecionada.refmaterialoferta));
  }

  const materiaisComboFiltrados = materiaisCombo.filter(
    (m) => !refsBloqueadas.includes(String(m.ref || ""))
  );

  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", md: "900px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Alternativas da oferta —{" "}
        {ofertaClienteAlternativasSelecionada?.materialoferta ||
          ofertaClienteAlternativasSelecionada?.refmaterialoferta ||
          ""}
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <MDBox display="grid" gap={2} mt={1}>
          <MDBox
            p={{ xs: 1.25, md: 2 }}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              maxWidth: "100%",
              overflowX: "auto",
            }}
          >
            <MDTypography variant="h6" mb={1}>
              {formOfertaClienteAlternativa.id ? "Editar alternativa" : "Nova alternativa"}
            </MDTypography>

            <MDBox
              display="grid"
              gridTemplateColumns={{
                xs: "1fr",
                sm: "1fr 1fr",
                lg: "2fr 0.7fr 0.7fr 2fr auto",
              }}
              gap={1}
              sx={{
                "& .MuiButton-root": {
                  width: { xs: "100%", lg: "auto" },
                },
              }}
            >
              <Autocomplete
                size="small"
                options={materiaisComboFiltrados}
                filterOptions={(x) => x}
                inputValue={alternativaInput}
                getOptionLabel={materialLabel}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      color: Number(option.inativo || 0) === 1 ? "#d32f2f" : undefined,
                      fontWeight: Number(option.inativo || 0) === 1 ? "bold" : undefined,
                    }}
                  >
                    {materialLabel(option)}
                  </li>
                )}
                value={
                  materiaisCombo.find(
                    (m) => m.ref === formOfertaClienteAlternativa.refmaterialalternativo
                  ) || null
                }
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setAlternativaInput(value);
                    setFormOfertaClienteAlternativa((p) => ({
                      ...p,
                      refmaterialalternativo: "",
                    }));
                    carregarMateriaisCombo(value);
                  }

                  if (reason === "clear") {
                    setAlternativaInput("");
                    setFormOfertaClienteAlternativa((p) => ({
                      ...p,
                      refmaterialalternativo: "",
                    }));
                  }
                }}
                onChange={(_, value) => {
                  setFormOfertaClienteAlternativa((p) => ({
                    ...p,
                    refmaterialalternativo: value?.ref || "",
                    unidade: value?.refmaterialunidade || p.unidade,
                  }));

                  setAlternativaInput(value ? materialLabel(value) : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Material alternativo" placeholder="Pesquisar..." />
                )}
              />

              <MDInput
                label="Qtd"
                type="number"
                value={formOfertaClienteAlternativa.qtd}
                onChange={(e) =>
                  setFormOfertaClienteAlternativa((p) => ({ ...p, qtd: e.target.value }))
                }
                fullWidth
              />

              <MDInput
                label="Unid."
                value={formOfertaClienteAlternativa.unidade}
                onChange={(e) =>
                  setFormOfertaClienteAlternativa((p) => ({ ...p, unidade: e.target.value }))
                }
                fullWidth
              />

              <MDInput
                label="Obs"
                value={formOfertaClienteAlternativa.obs}
                onChange={(e) =>
                  setFormOfertaClienteAlternativa((p) => ({ ...p, obs: e.target.value }))
                }
                fullWidth
              />

              <MDButton color="success" onClick={guardarOfertaClienteAlternativa}>
                {formOfertaClienteAlternativa.id ? "Atualizar" : "Adicionar"}
              </MDButton>
            </MDBox>
          </MDBox>

          <MDBox
            p={{ xs: 1.25, md: 2 }}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              maxWidth: "100%",
              overflowX: "auto",
            }}
          >
            <MDTypography variant="h6" mb={1}>
              Alternativas existentes
            </MDTypography>

            <table
              style={{
                width: "100%",
                minWidth: 760,
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Ref.</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material</th>
                  <th style={{ textAlign: "right", fontSize: 12, padding: 6 }}>Qtd</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Unid.</th>
                  <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Obs</th>
                  <th style={{ width: 80 }} />
                </tr>
              </thead>

              <tbody>
                {alternativas.map((a) => (
                  <tr key={a.id}>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {a.refmaterialalternativo}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {a.materialalternativo}
                    </td>
                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {a.qtd}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {a.unidade}
                    </td>
                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {a.obs}
                    </td>
                    <td style={{ borderTop: "1px solid #eee", whiteSpace: "nowrap" }}>
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() =>
                          abrirEditarAlternativaOfertaCliente(
                            ofertaClienteAlternativasSelecionada,
                            a
                          )
                        }
                        title="Editar alternativa"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => apagarAlternativaOfertaCliente(a)}
                        title="Eliminar alternativa"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </td>
                  </tr>
                ))}

                {alternativas.length === 0 && (
                  <tr>
                    <td colSpan={6} style={{ fontSize: 12, padding: 8, color: "#7b809a" }}>
                      Esta oferta ainda não tem alternativas.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
